/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {QueryChipModel} from '../../query-chips-area/models/query-chip.model';
import {GlobalSearchCriterionFilterModel} from '../../models/global-search-criterion-filter.model';

export class InputCriteriaTypeMapper {

    static fromInputCriteriaTypeToQueryChipsAreaModel(filter: GlobalSearchCriterionFilterModel,
                                                      formattedValue: string,
                                                      value?: unknown): QueryChipModel {
        let query: QueryChipModel;

        if (formattedValue != null && formattedValue !== '') {
            query = {
                filter: filter,
                formattedValue: formattedValue,
                value: value,
            };
        }
        return query;
    }
}
